import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  Col,
  Row,
  Form,
  Button,
  FormGroup,
  Label,
  Input,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
  Badge
} from "reactstrap";
import axios from "axios";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import { v4 as uuidv4 } from "uuid";
import { makeStyles } from "@material-ui/core/styles";
import moment from "moment";
import { puede } from "../../../../permisos/permisos";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
    },
  },
  button: {
    margin: theme.spacing(1),
  },
}));

function DocumentacionCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_DOCUMENTACION = process.env.REACT_APP_URL_DOCUMENTACION;
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;
  const URL_COMPRAS = process.env.REACT_APP_URL_COMPRAS;

  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");

 
  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  const [fecha, setFecha] = useState(hoy);
  const [descripcion, setDescripcion] = useState("NA");
  const [total, setTotal] = useState(0);
  const [proveedores, setProveedores] = useState([]);
  const [selectedProveedor, setSelectedProveedor] = useState("");

  const [compras, setCompras] = useState([]);
 
  const classes = useStyles();
  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      idCompras: "",
      saldo:0
    },
  ]);

  const [validaBoton, setValidaBoton] = useState(true);

  useEffect(() => {
  
    axios
    .get(`${URL_PROVEEDORES}Proveedores`, { 
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allProveedores = res.data;
        setProveedores(allProveedores);
      })
      .catch((err) => {
        console.log(err);
      });
  
  }, []);

  const saveDocumentacion = async (event) => {
    event.preventDefault();
    if (fecha != "" && descripcion != "" && selectedProveedor !="")  {
      setValidaBoton(false);
      toggleProgreso();

      let totalArticulos =inputFields.length
      try {
        await axios
          .post(
            URL_DOCUMENTACION,
            {
              fecha,
              descripcion,
              proveedores: selectedProveedor,
              total,
              saldo:total
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((data) => {
            inputFields.map((a) => {
                axios
                  .patch(
                    `${URL_COMPRAS}/documentado/${a.idCompras}`,
                    {
                      documentacion: data.data._id,
                      documentado:"Si"
                    },
                    {
                      headers: {
                        Authorization: `Bearer: ${localStorage.getItem(
                          "app_token"
                        )}`,
                      },
                    }
                  )
                  
                  .then(() => {
                    totalArticulos = totalArticulos - 1;
                    if (totalArticulos == 0) {
                      axios
                        .post(
                          URL_LOGS,
                          {
                            tipo: "Crear Documentacion",
                            detalle: `Proveedor ${selectedProveedor} / Documento ${data.data._id}`,
                            user: user.id,
                          },
                          {
                            headers: {
                              Authorization: `Bearer: ${localStorage.getItem(
                                "app_token"
                              )}`,
                            },
                          }
                        )
                        .then(() => {
                          Swal.fire("Good job!", "Creado con exito", "success");
                          setTimeout(() => {
                            window.location.reload();
                          }, 1000);
                        })
                        .catch((error) => {
                          Swal.fire({
                            icon: "error",
                            title: "Oops...",
                            text: "Something went wrong!",
                            footer: `${error.response.data}`,
                          });
                          console.log(error);
                          setValidaBoton(true);
                        });
                    }
                  })
                  .catch((error) => {
                    Swal.fire({
                      icon: "error",
                      title: "Oops...",
                      text: "Something went wrong!",
                      footer: `${error.response.data}`,
                    });
                    console.log(error);
                    setValidaBoton(true);
                  });
            });


          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `Faltan Datos`,
      });
    }
  };

  function BuscaCompra(id, event) {
      compras.map((a) => {
        if (a._id == event.target.value) {
          let idCompras = a._id;
          let saldo = a.saldo;
          handleChangeInput(id, idCompras, saldo);
        }
      });
  }

  const handleChangeInput = (id, idCompras, saldo) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.idCompras = idCompras;
        i.saldo = saldo
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales()
  };

  const handleAddFields = () => {

    setInputFields([
      ...inputFields,
      {
        id: uuidv4(),
        idCompras: "",
        saldo:0
      },
    ]);
  };

  const handleRemoveFields = (id) => {
    const values = [...inputFields];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFields(values);
   
  };

  function ActualizaTotales() {
    let cant = inputFields.map((c) => parseFloat(c.saldo));
    let TC = cant.reduce((t, total, index) => t + total, 0);
    setTotal(TC);
  }

  function jalaProveedor(e){
    setInputFields([
      {
        id: uuidv4(),
        idCompras: "",
        saldo:0
      },
    ]);
setSelectedProveedor(e)
    axios
    .get(`${URL_COMPRAS}DocumentacionCreate/${e}`, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((res) => {
      const allCompras = res.data;
     
      setCompras(allCompras);
    })
    .catch((err) => {
      console.log(err);
    });
  }

  return (
    <>
      <Header />
      <br />
      <br />
      {puede(user, "cxp.compras.ver") ? (
        <div className="card container col-10">
          <div className="page-header">
            <div>
              <h3 className="page-title">
                <i className="fas fa-file" style={{ marginRight: 8, color: "#0ea5e9" }} />
                Nueva Documentacion
              </h3>
            </div>
          </div>
          <Form onSubmit={saveDocumentacion}>
            <div className="form-section">
              <div className="form-section-header">
                <i className="fas fa-file" />
                <span className="form-section-title">Datos Generales</span>
              </div>
              <div className="form-section-body">
            <Row>

              <Col md={2}>
                <Label>Fecha</Label>
                <Input
                  type="date"
                  placeholder="Fecha"
                  value={fecha}
                  required
                  onChange={(e) => {
                    setFecha(e.target.value);
                  }}
                />
              </Col>
              <Col md={2}>
                <Label>Proveedor</Label>
                    <Input
                      name="proveedor"
                      type="select"
                      value={selectedProveedor}
                      required
                      onChange={(event) => {
                        jalaProveedor(event.target.value);
                      }}
                    >
                      <option value="">Selecciona un Proveedor</option>
                      {proveedores
                        .sort((a, b) =>
                        a.razon_social > b.razon_social ? 1 : -1
                      )
                      .map((a) => {
                          return (
                            <option value={a._id}>{a.razon_social}</option>
                          );
                      })}
                    </Input>
                  </Col>
           
            </Row>
            <Row>
              <Col md={6}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Descripcion
                </Label>
                <Input
                  type="text"
                  placeholder="Descripcion"
                  value={descripcion}
                  required
                  onChange={(e) => {
                    setDescripcion(e.target.value);
                  }}
                />
              </Col>
            </Row>
              </div>
            </div>

            {/* Tabla Articulos */}
            <div className="form-section">
              <div className="form-section-header">
                <i className="fas fa-list" />
                <span className="form-section-title">Partidas</span>
              </div>
              <div className="form-section-body">

            <Row>
              <Col md={6}>
                <Label className="mr-sm-2">Compra</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Total</Label>
              </Col>
              <Col md={2}>
              <h4 align="right">
                Total{"  "}
                <Badge
                  id="Total"
                  color="danger"
                  className="BadgeSize badge-pill"
                >
                  {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(total)}
                </Badge>
              </h4>
            </Col>
            </Row>

            {inputFields.map((inputField) => (
              <div key={inputField.id}>
                <Row>
                  <Col md={6}>
                    <Input
                      bsSize="sm"
                      name="compra"
                      type="select"
                      value={inputField.idCompras}
                      required
                      onChange={(event) =>
                        BuscaCompra(inputField.id, event)
                      }
                    >
                      <option value="">Selecciona una Compra</option>
                      {compras
                      .sort((a, b) => (a.idCompras > b.idCompras ? 1 : -1))
                        .map((a) => {
                          return (
                            <option value={a._id}>
                               {a.idCompras} / {a.fecha} / {a.factura_proveedor}
                            </option>
                          );
                        })}
                    </Input>
                  </Col>


                  <Col md={1}>
                    <Input
                      bsSize="sm"
                      name="saldo"
                      type="number"
                      min="0"
                      step="any"
                      value={inputField.saldo}
                      disabled
                    ></Input>
                  </Col>

                  <Col>
                    <Button
                      size="sm"
                      className="btn"
                      color="danger"
                      disabled={inputFields.length === 1}
                      onClick={() => handleRemoveFields(inputField.id)}
                      tabindex="-1"
                    >
                      <i class="fas fa-minus"></i>
                    </Button>
                    <Button
                      size="sm"
                      className="btn"
                      color="info"
                      onClick={handleAddFields}
                      tabindex="-1"
                    >
                      <i class="fas fa-plus"></i>
                    </Button>
                  </Col>
          
                </Row>
              </div>
            ))}
          
            {/* Termina Tabla Articulos */}
              </div>
            </div>

            <br />
            <div className="submit-bar">
            <Button
              href="/ListadoDocumentacion"
              className="btn btn-danger"
              id="botonListado"
            >
              Regresar
            </Button>
            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                <i className="fas fa-save" style={{ marginRight: 6 }} /> Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                <i className="fas fa-save" style={{ marginRight: 6 }} /> Guardar
              </Button>
            )}
            </div>
          </Form>
          <br />
         <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
             <h4> Este proceso puede tardar varios segundos.
              <br />
              Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                  <Spinner
                    style={{
                      width: "50px",
                      height: "50px",
                      color: "#232B41",
                    }}
                  />
                  <Spinner
                    style={{
                      width: "50px",
                      height: "50px",
                      color: "#232B41",
                    }}
                  />
                  <Spinner
                    style={{
                      width: "50px",
                      height: "50px",
                      color: "#232B41",
                    }}
                  />
              </div>
            </ModalBody>
          </Modal>
        </div>
      ) : undefined}
    </>
  );
}

export default DocumentacionCreate;
